import React, { useState } from 'react';
import { StyledSider, StyledMenu } from './style';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { LogoutOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { white_logo } from '../../constants/images';

function SiderAdmin() {
  const [collapsed, setCollapsed] = useState(false);

  function logout() {
    localStorage.removeItem('opentrace_token');
    window.location.replace('/login');
  }

  return (
    <StyledSider
      collapsible
      collapsed={collapsed}
      onCollapse={() => setCollapsed(!collapsed)}
    >
      <div className={collapsed ? 'logo-collapsed' : 'logo'}>
        {/* <div> */}
        <img src={white_logo} alt="" />
        {/* <span className="logo-span">{collapsed ? 'OT' : 'OpenTrace'}</span> */}
      </div>
      <StyledMenu theme="dark" defaultSelectedKeys={['1']} mode="inline">
        {/* <Menu.Item path="/" key="1" icon={<ShopOutlined />}>
          <Link to="/" className="nav-text">
            Dashboard
          </Link>
        </Menu.Item> */}
        <Menu.Item key="1" icon={<UsergroupAddOutlined />}>
          <Link to="/user-management" className="nav-text">
            User Management
          </Link>
        </Menu.Item>
      </StyledMenu>
      <div className="username">
        {!collapsed && (
          <span>
            {localStorage.getItem('username') &&
              localStorage.getItem('username').toUpperCase()}
          </span>
        )}
      </div>
      <div className="logout" onClick={logout}>
        <LogoutOutlined />

        {!collapsed && <span>Log out</span>}
      </div>
    </StyledSider>
  );
}

export default SiderAdmin;
